import React from "react";
import ArchivePageHeaderDescription from "archive/components/ArchivePageHeaderDescription";
import ArchiveActions from "archive/ArchiveActions";
import ArchiveCatalog from "archive/components/ArchiveCatalog";
import ArchiveCreationSection from "archive/components/ArchiveCreationSection";
import ArchiveSystemJobs from "archive/components/ArchiveSystemJobs";
import DocsHelper from "util/DocsHelper";
import useArchiveIndicesSummary from "archive/hooks/useArchiveIndicesSummary";
import { DocumentTitle, ExternalLinkButton, PageHeader, IfPermitted } from "components/common";
import { Button, Row, Col } from "components/bootstrap";
import ArchivePageNavigation from "./components/ArchivePageNavigation";
const ArchivePage = () => {
  const { data } = useArchiveIndicesSummary();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Archives" }, /* @__PURE__ */ React.createElement(ArchivePageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "Archives" }, /* @__PURE__ */ React.createElement(ArchivePageHeaderDescription, null)), /* @__PURE__ */ React.createElement(ArchiveCreationSection, { indices: data == null ? void 0 : data.indices }), /* @__PURE__ */ React.createElement(ArchiveSystemJobs, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("div", { className: "pull-right" }, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "archivecatalog:rebuild" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "info",
      onClick: () => {
        ArchiveActions.rebuildCatalog();
      }
    },
    "Rebuild Catalog"
  ), "\xA0"), /* @__PURE__ */ React.createElement(ExternalLinkButton, { bsStyle: "info", href: DocsHelper.toString("archiving") }, "Archive documentation")), /* @__PURE__ */ React.createElement(ArchiveCatalog, null))));
};
export default ArchivePage;
